import Auth from '@aws-amplify/auth';
import { SOCIAL_SIGNIN_DOMAIN } from '../util/AppConstant';
import { AmplifyCustomStorage } from '../util/AmplifyCustomStorage';
import { getURLOrigin  } from '../util/AppUtil';
 
// Store the optin value so we can reference it later
let persistedLogin = true;

/**
 * Returns the configured value for persisted login
 * @returns {boolean}
 */
export function isPersistedLogin() {
    return persistedLogin;
}

/**
 * Configuring amplify auth with appropriate properties received from iamconfig endpoint.
 * Added condition of socialEnabled flag, because in normal flow /oauth2/token call is getting called and that is not valid. 
 * @param {*} awsConfig - configdata from /iamconfig endpoint
 * @param {boolean} optIn - user opting in or opting out of persistence.
 */
export function configureAmplifyAuth(awsConfig, optIn) {

    // Store this value so we can access it outside the configuration or after the login event from the Amplify Hub
    persistedLogin = optIn;

    // Base config
    const config = {
        userPoolId: awsConfig.userPoolId,
        userPoolWebClientId: awsConfig.appClientId,
        region: awsConfig.region,
        authenticationFlowType: 'USER_PASSWORD_AUTH',
        storage: AmplifyCustomStorage
    };

    const origin = getURLOrigin();
    // Add oauth stuff
    if(awsConfig.socialEnabled){
        config.oauth = {
            domain: SOCIAL_SIGNIN_DOMAIN,
            scope: ['email', 'openid', 'phone', 'profile', 'aws.cognito.signin.user.admin'],
            redirectSignIn: origin + '/social/callback',
            redirectSignOut: origin + '/logout',
            responseType: 'code'
        };
        config.federationTarget = 'COGNITO_USER_POOLS'
    }

    Auth.configure(config);
    Auth.userPool.client.endpoint = awsConfig.endPointUrl;

}